import { getCasinoRoutes } from '~/components/router/casino-routes';

const getGameUrls = ({ code, categoryCode = '' }: { code: string; categoryCode?: string }, license: string) => {
	const { ROUTE_CASINO_GAME, ROUTE_LIVE_CASINO_GAME } = getCasinoRoutes(license);
	const route = categoryCode === 'CASINO_LIVE_CASINO' ? ROUTE_LIVE_CASINO_GAME : ROUTE_CASINO_GAME;
	return {
		realModeUrl: `${route}/${code}/real`,
		funModeUrl: `${route}/${code}/fun`
	};
};

export default getGameUrls;
